import  { useEffect, useState } from 'react'

import webapplogo from "../assest/webapplogo.png"

import CustomButton from '../Components/CustomButton'
import CustomPasswordInput from '../Components/CustomInputPassword'
import { useNavigate } from 'react-router-dom'
import { authPassword } from '../redux/actions/authAction'
import { notification } from 'antd';
import { getOrganizationBySlug } from '../redux/actions/myorganization.action'

const ResetPassword = () => {

    const [Password, setPassword] = useState('')

    const openErrorNotification = () => {
        notification.error({
          message: 'Password Error',
          description: 'Passwords do not match.',
          placement: 'topRight',
        });
      };
    
    const [confirmPassword, setConfirmPassword] = useState('')
    const [token, setToken] = useState(null);
     const navigate = useNavigate()

     let organizationid= localStorage.getItem('organizationid')

    useEffect(() => {
        // Get query parameters from the URL
        const queryParameters = new URLSearchParams(window.location.search);
    
        // Get the 'token' from the query string
        const token = queryParameters.get('token');       
    
        let slug = queryParameters.get('slug');
        
 
        
        console.log('Extracted slug:', slug);
        
        // If slug exists, fetch organization data
        if (slug) {
            console.log('Calling getOrganizationBySlug with slug:', slug);
            // Call the API to get organization by slug
            getOrganizationBySlug(slug)
        }

        if (token) {
          // Store token in the state
          setToken(token);       
        }
      }, []);

const setpassword=()=>{
    try {
        // Check if both password fields are filled
        if (!Password || !confirmPassword) {
            notification.error({
                message: 'Password Error',
                description: 'Please fill in both password fields.',
                placement: 'topRight',
            });
            return; // Prevent form submission
        }
        
        // Check if passwords match
        if (Password !== confirmPassword) {
            openErrorNotification();
            return; // Prevent form submission
        }

        // Only proceed if token exists and passwords match
        if(token) {
            // Extract email from slug if available
            const queryParameters = new URLSearchParams(window.location.search);
            const slug = queryParameters.get('slug');
            let email_address = null;
            
            // Try to extract email from slug if available
            if (slug) {
                const parts = slug.split('-');
                if (parts.length > 0) {
                    const emailPart = parts[parts.length - 1];
                    if (emailPart.includes('@')) {
                        email_address = emailPart;
                    }
                }
            }
            
            const payload = {
                password_reset_token: token,
                Password,
                organizationid,
                email_address // Include email address in payload
            }
            
            authPassword(payload, navigate);
        }

    } catch (error) {
        console.log('error', error);
        notification.error({
            message: 'Error',
            description: 'An error occurred while updating your password.',
            placement: 'topRight',
        });
    }
}

    return (


        <div className='loginpagemain'>

            <div className='loginpage'>

                {/* <Image className='webimage' src={webapplogo}/> */}
                <img className='webimage' src={webapplogo} alt=''></img>

                <p>
                    Update Password

                </p>
                <h2>Please enter details</h2>
                <div className='textinput'>
                    

                    <p >
                        Password
                    </p>
                    <CustomPasswordInput value={Password} onChange={setPassword} />

                    
                    <p style={{marginTop:'10px'}} >
                       Confirm Password
                    </p>
                    <CustomPasswordInput value={confirmPassword} onChange={setConfirmPassword} />
                    <CustomButton  onClick={setpassword}
                    // onClick={()=>{
                    //      navigate('/verfication')
                    // }} 
                    
                    text={'Update Password'} />

                   
                </div>

            </div>

        </div>
    )
}

export default ResetPassword